'use client'

import { useFeatureToggle } from '@/components/utils/FeatureToggleContext'
import { useServerEnvInfo } from '@/components/utils/ServerEnvironmentContext'
import { useUserProfile } from '@/hooks/business/useUserProfile'
import { getPermissions, Permission } from '@/lib/permissions'
import { useParams } from 'next/navigation'

export function usePermissions(): Permission[] {
  const profile = useUserProfile()
  const departureStation = useParams()
  const override = useFeatureToggle('FT_PERMISSIONS_OVERRIDE')
  const { serverEnv } = useServerEnvInfo()

  if (!profile || !departureStation.departureStation) {
    return []
  }

  const atHomeCity = profile.city === departureStation.departureStation
  const allRoles = profile.roles
  return getPermissions(allRoles, atHomeCity, serverEnv, override)
}

export function usePermissionValidation(permission: Permission): boolean {
  const permissions = usePermissions()
  const hasPermission = permissions.includes(permission)

  return hasPermission
}
